export const AGE_VERIFIED_STORAGE_KEY = 'checkout-age-verified';

export function getInitialAgeVerified(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.sessionStorage.getItem(AGE_VERIFIED_STORAGE_KEY) === 'true'
  );
}

export function setAgeVerifiedStorage(value: boolean): void {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(AGE_VERIFIED_STORAGE_KEY, String(value));
  }
}

export function clearAgeVerifiedStorage(): void {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(AGE_VERIFIED_STORAGE_KEY);
  }
}
